/* eslint-disable max-len */
/* eslint-disable no-catch-shadow */
/* eslint-disable no-shadow */
/* eslint-disable no-console */
import React, { useState, useEffect, useRef } from 'react';
import { Box, Checkbox, Typography, Stack, Breadcrumbs, Link, Grid } from '@mui/material';
import { getFolder, getBreadCrumbs } from '../../../../../../../../actions/media_actions';
import ReactPlayer from 'react-player';
import { toast } from 'react-toastify';
import NoData from '../../../../../../../../../components/Common/NoData';
import Radio from '@mui/material/Radio';

interface MediaItem {
    url: string;
    key: string;
    type: string;
    name: string;
    size: number;
}

interface FolderItem {
    name: string;
    type: 0 | 1;
    parent: string;
    media?: MediaItem;
    mediaType: number;
    parentPath: string[];
    shareTo: string[];
    ownerId: string;
    createdBy: string;
    folderId: string;
    createdAt: number;
    updatedAt: number;
    uploadedBy: string;
}

interface MediaDriveProps {
	singleSelection?: boolean;
    fileType?: string;
    userData: any;
    selectedItems: any[];
    setSelectedItems: React.Dispatch<React.SetStateAction<any[]>>;
}

interface QueryParams {
    uid: string;
    comid: string;
    empRole: string;
    role: string;
    limit: number;
    skip: number;
    mediaType?: string;
    id?: string;
}

interface BreadcrumbItem {
    name: string;
    id: string;
    companyId: string;
}

const ITEMS_PER_PAGE = 12;
const MAX_SELECTION_LIMIT = 5;

const MediaDrive: React.FC<MediaDriveProps> = ({ fileType, userData, selectedItems,
	setSelectedItems, singleSelection }) =>
{
	const [ folders, setFolders ] = useState<FolderItem[]>([]);
	const [ loading, setLoading ] = useState<boolean>(false);
	const [ error, setError ] = useState<string | null>(null);
	const [ currentPage, setCurrentPage ] = useState<number>(0);
	const [ currentPath, setCurrentPath ] = useState<string>('/');
	const [ totalCount, setTotalCount ] = useState<number>(0);
	const [ breadcrumbs, setBreadcrumbs ] = useState<BreadcrumbItem[]>([]);

	// Add ref for the last element
	const lastElementRef = useRef<HTMLDivElement>(null);
	// Add a scrollRef to maintain scroll position
	const scrollContainerRef = useRef<HTMLDivElement>(null);
	// Save the current scroll position
	const scrollPositionRef = useRef<number>(0);

	console.log('fileType==============>', fileType);

	// Fetch folders function
	const fetchFolders = async () =>
	{
		if (loading) return;

		// Save scroll position before loading
		if (scrollContainerRef.current)
		{
			scrollPositionRef.current = scrollContainerRef.current.scrollTop;
		}

		setLoading(true);
		try
		{
			const queryParams: QueryParams = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role,
				limit   : ITEMS_PER_PAGE,
				skip    : currentPage
			};

			if (fileType)
			{
				const slectedTyep = fileType.toLocaleLowerCase() === 'image' ? [ 3 ] : fileType === 'video' ? [ 5 ] : fileType === 'document' ? [ 2 ] : [];

				queryParams.mediaType = JSON.stringify([ 1, ...slectedTyep ]);
			}

			if (currentPath !== '/')
			{
				queryParams.id = currentPath;
			}

			const response = await getFolder(queryParams, 'folders');

			if (response.status)
			{
				if (currentPage === 0)
				{
					setFolders(response.data);
				}
				else
				{
					setFolders((prev) => [ ...prev, ...response.data ]);
				}

				if (currentPage === 0 && response.data.length >= ITEMS_PER_PAGE)
				{
					const countResponse = await getFolder({ ...queryParams, count: true }, 'folders');

					if (countResponse.status)
					{
						setTotalCount(countResponse.count);
					}
				}
				else if (currentPage === 0)
				{
					setTotalCount(response?.data?.length);
				}
			}
			else
			{
				setError('Failed to fetch folders');
			}
		}
		catch (err: unknown)
		{
			setError(err instanceof Error ? err.message : 'Error fetching folders');
		}
		finally
		{
			setLoading(false);

			// Restore scroll position after loading
			setTimeout(() =>
			{
				if (scrollContainerRef.current && currentPage > 0)
				{
					scrollContainerRef.current.scrollTop = scrollPositionRef.current;
				}
			}, 0);
		}
	};

	// Fetch breadcrumbs function
	const fetchBreadcrumbs = async (folderId: string) =>
	{
		try
		{
			const queryParams = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role,
				id      : folderId
			};

			const response = await getBreadCrumbs(queryParams);

			if (response.status)
			{
				setBreadcrumbs(response.data);
			}
		}
		catch (err)
		{
			console.error('Error fetching breadcrumbs:', err);
		}
	};

	// Update useEffect for Intersection Observer
	useEffect(() =>
	{
		const options = {
			root       : null,
			rootMargin : '0px',
			threshold  : 0.5
		};

		const observer = new IntersectionObserver((entries) =>
		{
			const [ entry ] = entries;

			if (entry.isIntersecting && !loading && totalCount > folders.length)
			{
				setCurrentPage((prev) => prev + 1);
			}
		}, options);

		const currentRef = lastElementRef.current;

		if (currentRef)
		{
			observer.observe(currentRef);
		}

		return () =>
		{
			if (currentRef)
			{
				observer.unobserve(currentRef);
			}
		};
	}, [ loading, totalCount, folders.length, lastElementRef.current ]);

	// Add useEffect for fetching folders
	useEffect(() =>
	{
		fetchFolders();
	}, [ currentPage, currentPath ]);

	// Handle folder click
	const handleFolderClick = async (folderId: string) =>
	{
		setCurrentPage(0);
		setCurrentPath(folderId);
		await fetchBreadcrumbs(folderId);
		// Reset scroll position when navigating to a new folder
		if (scrollContainerRef.current)
		{
			scrollContainerRef.current.scrollTop = 0;
		}
	};

	// Handle breadcrumb click
	const handleBreadcrumbClick = async (folderId: string) =>
	{
		setCurrentPage(0);
		setCurrentPath(folderId);
		folderId !== '/' ? await fetchBreadcrumbs(folderId) : setBreadcrumbs([]);
		// Reset scroll position when navigating via breadcrumb
		if (scrollContainerRef.current)
		{
			scrollContainerRef.current.scrollTop = 0;
		}
	};

	// Handle file selection
	const handleSelect = (obj: FolderItem) =>
	{
		setSelectedItems((prev) =>
		{
			const exists = prev.some((item) => item.key === obj.media?.key);

			if (exists)
			{
				return prev.filter((item) => item.key !== obj.media?.key);
			}
			else
			{
				// For image type, replace the previous selection
				if (fileType === 'Image' || singleSelection) // don't change this to lowercase
				{
					return [ obj?.media ];
				}

				// For other types, check the selection limit
				if (prev.length >= MAX_SELECTION_LIMIT)
				{
					toast.error(`Maximum ${MAX_SELECTION_LIMIT} items can be selected`);

					return prev;
				}

				return [ ...prev, obj?.media ];
			}
		});
	};

	return (
		<Box
			sx={{
				display        : 'flex',
				flexDirection  : 'column',
				gap            : 2,
				width          : '100%',
				position       : 'relative',
				height         : '350px',
				justifyContent : 'start'
			}}
		>
			<Stack direction={'column'} alignItems={'start'}>
				{/* temporary hide select all */}
				{/* <FormControlLabel
					control={
						<Checkbox
							size='small'
							checked={selectAll}
							onChange={handleSelectAll}
						/>
					}
					label={'Select All'}
					sx={{ alignSelf                      : 'flex-end',
						'& .MuiFormControlLabel-label' : {
							color      : '#212121',
							fontWeight : 400,
							fontSize   : 14
						}
					}}
				/> */}
				<Typography width={'100%'} textAlign={'start'} fontWeight={600} fontSize={24} color={'#333333'}>
					Choose files
				</Typography>

				<Breadcrumbs separator='/' aria-label='breadcrumb'>
					<Link
						href='#'
						onClick={() => handleBreadcrumbClick('/')}
						sx={{ fontSize: 12, fontWeight: 600, color: '#333333' }}
					>
						All {fileType}s
					</Link>
					{breadcrumbs.map((item, index) => (
						index === breadcrumbs.length - 1
							? (
								<Typography
									key={item.id}
									sx={{
										fontSize   : 12,
										fontWeight : 600,
										color      : '#333333',
										cursor     : 'default'
									}}
								>
									{item.name}
								</Typography>
							)
							: (
								<Link
									key={item.id}
									href='#'
									onClick={() => handleBreadcrumbClick(item.id)}
									sx={{ fontSize: 12, fontWeight: 600, color: '#333333' }}
								>
									{item.name}
								</Link>
							)
					))}
				</Breadcrumbs>
			</Stack>

			{/* Conditional rendering of content */}
			{(() =>
			{
				if (loading && currentPage === 0)
				{
					return (
						<Box display='flex' justifyContent='center' alignItems='center' height='100%'>
							<Typography>Loading...</Typography>
						</Box>
					);
				}

				if (error)
				{
					return (
						<Box display='flex' justifyContent='center' alignItems='center' height='100%'>
							<Typography color='error'>{error}</Typography>
						</Box>
					);
				}

				if (folders.length === 0)
				{
					return (
						<Box display='flex' justifyContent='center' alignItems='center' height='100%'>
							<NoData noDataHead={'No data found'} color='lightTxt' src1='/images/Bpsnodata.svg' />
						</Box>
					);
				}

				return (
					<Grid container
						ref={scrollContainerRef}
						direction={'row'}
						sx={{
							flexWrap  : 'wrap',
							gap       : 2,
							width     : '100%',
							overflow  : 'auto',
							maxHeight : '300px'
						}}
					>
						{folders.map((item, index) => (
							<Grid item
								xs={2.8}
								key={item.folderId}
								ref={index === folders.length - 1 ? lastElementRef : null}
								sx={{
									maxHeight      : '175px',
									border         : '1px solid #24A4C4',
									borderRadius   : '4px',
									overflow       : 'hidden',
									cursor         : 'pointer',
									display        : 'flex',
									flexDirection  : 'column',
									justifyContent : 'space-between'
								}}
								onClick={() => (item.type === 0 ? handleFolderClick(item.folderId) : handleSelect(item))}
								p={1}
							>
								{item.mediaType !== 1 &&
								<Box display={'flex'} justifyContent={'end'}>
									{(fileType === 'Image' || singleSelection)
										? (
											<Radio
												checked={selectedItems.some((selectedItem) => selectedItem.key === item.media?.key)}
												size='small'
												sx={{
													backgroundColor : 'transparent',
													borderRadius    : '50%',
													p               : 0
												}}
											/>)
										: (
											<Checkbox
												checked={selectedItems.some((selectedItem) => selectedItem.key === item.media?.key)}
												size='small'
												sx={{
													backgroundColor : 'transparent',
													borderRadius    : '50%',
													p               : 0
												}}
											/>
										)
									}
								</Box>}

								{item.mediaType === 1
									? (
										<img
											src='/images/icons/folder.svg'
											alt={item.name}
											style={{
												aspectRatio  : 16 / 9,
												objectFit    : 'contain',
												borderRadius : '8px'
											}}
										/>
									)
									: item.mediaType === 5 || (item.media?.type && item.media.type.startsWith('video/'))
										? (
											<ReactPlayer
												url={item.media?.url}
												width='100%'
												height='auto'
												style={{
													aspectRatio  : 16 / 9,
													borderRadius : '8px',
													maxHeight    : '100px'
												}}
												pip={false}
											/>
										)
										: (
											<img
												src={item?.mediaType === 2 ? `/documents/${item?.media?.key?.split('.')?.[1] || 'txt'}.png` : item?.media?.url}
												alt={item.name}
												style={{
													aspectRatio  : 16 / 9,
													objectFit    : item.type === 1 ? 'cover' : 'contain',
													borderRadius : '8px'
												}}
											/>
										)}
								<Grid container direction={'row'} pt={1} alignItems={'center'} justifyContent={'space-between'} width={'100%'} >
									<Grid item xs={2} display={'flex'} alignItems={'center'} justifyContent={'center'}>
										<Box component={'img'} sx={{ height: 20, width: 20, objectFit: 'contain' }}
											src={`/documents/${item?.mediaType === 1 ? 'folder' : (item?.media?.key?.split('.')?.[1] || 'txt')}.png`}
										/>
									</Grid>
									<Grid item xs={8} display={'flex'} flexDirection={'column'} justifyContent={'center'}>
										<Typography
											variant='body2'
											sx={{
												color        : '#24A4C4',
												fontSize     : '12px',
												overflow     : 'hidden',
												textOverflow : 'ellipsis',
												whiteSpace   : 'nowrap',
												width        : '100%'
											}}
										>
											{item.name}
										</Typography>
										<Typography
											sx={{
												fontSize     : '10px',
												overflow     : 'hidden',
												textOverflow : 'ellipsis',
												whiteSpace   : 'nowrap',
												width        : '100%',
												color        : '#737373'
											}}
										>
											{item.uploadedBy}
										</Typography>
									</Grid>
								</Grid>
							</Grid>
						))}
						{loading && currentPage > 0 && (
							<Grid item xs={12} sx={{ textAlign: 'center', py: 2 }}>
								<Typography>Loading more...</Typography>
							</Grid>
						)}
					</Grid>
				);
			})()}
		</Box>
	);
};

export default MediaDrive;
